import { render, staticRenderFns } from "./PopChangeBasicInfo.vue?vue&type=template&id=1fa05213"
import script from "./PopChangeBasicInfo.vue?vue&type=script&lang=js"
export * from "./PopChangeBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./PopChangeBasicInfo.vue?vue&type=style&index=0&id=1fa05213&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports